import { KeyboardEvent } from "react";
import {
  getFocusableElements,
  hasModifierKey,
  isNavigableTarget,
} from "./focus";

/**
 * Moves the focus between the focusable elements of a vertical list with
 * ArrowUp/ArrowDown (wrapping around), Home and End.
 */
export function handleListNavigation(event: KeyboardEvent<HTMLElement>) {
  if (hasModifierKey(event) || !isNavigableTarget(event.target)) return;

  const items = getFocusableElements({ element: event.currentTarget });
  const index = items.indexOf(event.target);
  const nextIndex = getNextIndex(event.key, index, items.length);
  if (nextIndex === null) return;

  event.preventDefault();
  items[nextIndex]?.focus();
}

function getNextIndex(key: string, index: number, length: number) {
  if (length === 0) return null;
  switch (key) {
    case "ArrowDown":
      return (index + 1) % length;
    case "ArrowUp":
      return index <= 0 ? length - 1 : index - 1;
    case "End":
      return length - 1;
    case "Home":
      return 0;
    default:
      return null;
  }
}
